// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"b1d6401e","453":"82114a2f"}[chunkId] + ".chunk.js";
};